var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 217,
    viewBox: "0 0 1280 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9759 33.5843C-4.29061 -5.6459 -99.5893 -10.7393 -131 21.5C-91.6628 103.489 -39.7585 463.225 -36.0458 469.201C-32.3332 475.176 81.9088 535.047 116.886 631.485L1472.14 351.87L1573.53 130.545C1358.37 294.05 1215.15 300.081 1125.38 215.223C1052.38 146.223 909.321 99.5733 807.877 147.723C774.769 163.437 617.958 261.539 507.377 158.575C396.796 55.6104 329.377 147.723 226.916 158.575C125.558 169.31 147.059 82.6221 62.9759 33.5843Z",
    fill: "url(#paint0_linear_5064_51017)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5064_51017",
    x1: -93.1231,
    y1: -17.2771,
    x2: 394.377,
    y2: 309.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD1822"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkWaves);
export default __webpack_public_path__ + "static/media/DarkWaves.affcbce855e19df1004e648b23f7cada.svg";
export { ForwardRef as ReactComponent };